import React, { useState } from 'react';
import styles from 'routes/adminMobile/components/AdminMobileYearSaleStat.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainColor, mainPadd2, pageEH2FontSize, registerGap2, statDetailFontColor } from 'routes/adminMobile/constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import backIcon from 'routes/vendorRe/images/back_icon.png';

const AdminMobileYearSaleStat = ({storeData}) => {
    //

    // 현재 년도 상태를 관리하는 useState 훅
    const [yearState, setYearState] = useState(new Date().getFullYear()); // 현재 년도 설정

    // storeData가 존재하지 않는 경우에 대한 예외 처리
    if (!storeData) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    // 물품 대금을 저장할 변수
    let totalSupplyPrice = 0;
    // products와 buyers 배열을 순회하며 물품 대금을 계산
    storeData.products.forEach(product => {
        storeData.buyers.forEach((buyer, index) => {
            // 현재 제품 번호와 구매자가 구매한 해당 제품의 수량을 확인
            const productIndex = buyer.productNo.indexOf(product.productNo);
            if (productIndex !== -1) {
                // 해당 제품의 공급가와 수량을 곱하여 물품 대금에 더함
                totalSupplyPrice += product.productSupplyPrice * buyer.productCnt[productIndex];
            }
        });
    });
    //

    // 총 매출 변수
    let totalSale = storeData.totalSales;
    // 카드 수수료 계산 (3.3%)
    const cardCommission = totalSale * 0.033;
    // 부가세 계산 (10%)
    const vat = totalSale * 0.1;
    // 최종 정산 예정 금액 계산 (총 매출 - 물품 대금 - 카드 수수료 - 부가세)
    const finalSettlementAmount = totalSale - totalSupplyPrice - cardCommission - vat;
    //
    //
    //

    // 이전 년도로 이동하는 함수
    const goToPrevYear = () => {
        setYearState(prevYear => prevYear - 1); // 현재 년도에서 1을 빼서 이전 년도로 이동
    };

    // 다음 년도로 이동하는 함수
    const goToNextYear = () => {
        setYearState(nextYear => nextYear + 1); // 현재 년도에서 1을 더해서 다음 년도로 이동
    };

    return (
        <AdminMobileContentBox>
            <VerticalFlex gap={registerGap2}>
                <FlexChild>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex>
                            <FlexChild width="auto">
                                <img className={styles.prevIcon} src={backIcon} alt='이동 아이콘' onClick={goToPrevYear} />
                            </FlexChild>
                            <FlexChild justifyContent="center">
                                <P size={pageEH2FontSize}>
                                    {yearState && yearState} 판매량 합계
                                </P>
                            </FlexChild>
                            <FlexChild width="auto">
                                <img className={styles.nextIcon} src={backIcon} alt='이동 아이콘' onClick={goToNextYear} />
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild padding="0.5rem 0 1rem">
                            <VerticalFlex gap={registerGap2}>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={pageEH2FontSize} color={statDetailFontColor}>총 매출</P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end">
                                            <P size={pageEH2FontSize} color={statDetailFontColor} weight={700}>
                                                {storeData.totalSales ? storeData.totalSales.toLocaleString() : 0}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={pageEH2FontSize} color={statDetailFontColor}>물품 대금</P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end">
                                            <P size={pageEH2FontSize} color={statDetailFontColor} weight={700}>
                                                {totalSupplyPrice ? (`- `) + totalSupplyPrice.toLocaleString() : 0}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={pageEH2FontSize} color={statDetailFontColor}>카드 수수료</P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end">
                                            <P size={pageEH2FontSize} color={statDetailFontColor} weight={700}>
                                                {cardCommission ? (`- `) + cardCommission.toLocaleString() : 0}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={pageEH2FontSize} color={statDetailFontColor}>부가세</P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end">
                                            <P size={pageEH2FontSize} color={statDetailFontColor} weight={700}>
                                                {vat ? (`- `) + vat.toLocaleString() : 0}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <HorizontalFlex>
                                <FlexChild>
                                    <P size={pageEH2FontSize}>이번달 정산 예정 금액</P>
                                </FlexChild>
                                <FlexChild justifyContent="flex-end">
                                    <P size={pageEH2FontSize} weight={700} color={mainColor}>
                                        {finalSettlementAmount ? finalSettlementAmount.toLocaleString() : 0}
                                    </P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </AdminMobileContentBox>
    );
};

export default AdminMobileYearSaleStat;